// extracted by mini-css-extract-plugin
export default {"disabled":"linkStyle_disabled__MwcHt"};